import React, { useState, useEffect } from "react";
import "./CreateUser.css";
import { FaRegUser } from "react-icons/fa";
import { FiChevronDown } from "react-icons/fi";
import { useSelector, useDispatch } from "react-redux";
import { Form, Button } from "react-bootstrap";
import { endPoints } from "../../../constant/Environment";
import { updateData, getAllData, updateUser } from "../../../Utility/API";
import Toaster from "../../../components/Toast";
import { Actions } from "../../../redux/Actions/Actions";
import Loader from "../../../components/Loader";
import Image from "react-bootstrap/Image";
import { useNavigate } from "react-router-dom";
import { ErrorToast, SuccesToast } from "../../../components/Toast/message";
//import DatePicker from "react-datepicker"
//import "react-datepicker/dist/react-datepicker.css";

const CreateUser = (props) => {
  const state = useSelector((state) => state.auth);
  //    console.log('selected', state.selected.idUser)
  const User = state?.selected;
  const dispatch = useDispatch();
  let navigate = useNavigate();
  const [name, setName] = useState(User?.name || "");
  const [idUser]=useState(User?.idUser || 0);
  const [surname, setSurname] = useState(User?.surname || "");
  const [type, setType] = useState(User?.type || 0);
  const [date, setDate] = useState(new Date());
  const [nation, setNation] = useState(User?.nation || "");
  const [country, setCountry] = useState(User?.country || "");
  const [states, setStates] = useState([]);
  const [message, setMessage] = useState("");
  const [town, setTown] = useState(User?.town || "");
  const [address, setAddress] = useState(User?.address || "");
  const [docNum, setDocNum] = useState(User?.documentId || "");
  const [secretq, setsecretq] = useState(User?.personalQuestion || "");
  const [sex, setGender] = useState(User?.sex || "");
  const [doctype, setDoctype] = useState(User?.documentTypeId || "");
  const [personalres, setPersonalRes] = useState(User?.personalResponse || "");
  const [isLoading, setIsLoadinig] = useState(false);
  const [userName, setUserName] = useState(User.login || "");
  const [email, setEmail] = useState(User.email || "");
  const [password, setPassword] = useState(User.passwd || "");
  const [validated, setValidated] = useState(false);
  const [questionArr, setQuestionArr] = useState([]);
  const [documentArr, setDocumentArr] = useState([]);
  const [activeSuspend,setActiveSuspend] = useState(User?.activation || 1)

  const typearr = [
    {
      name: "VISITOR",
      value: -1,
    },
    {
      name: "FINANCIAL",
      value: 0,
    },
    {
      name: "TRADER",
      value: 1,
    },
    {
      name: "USER",
      value: 2,
    },
    {
      name: "OPERATOR",
      value: 3,
    },
    {
      name: "AGENCY",
      value: 4,
    },
  ];
  const accountType=[
    {
      name:"Active",
      value:"1"
    },
    {
      name:'Suspend',
      value:'0'
    }
  ]

 
  useEffect(() => {
    GetStates();
 
    GetPersonalQues();
    GetDocumnets();
    return () => {
      dispatch({
        type: Actions.CLEAR_SELECTED,
      });
    };
  }, []);
  const GetStates = () => {
    let url = `${endPoints.api.STATES}`;
    setIsLoadinig(true);
    getAllData(url)
      .then((response) => {
        const { status, data, message } = response;

        setIsLoadinig(false);
        if (status === "success") {
          let statesKey = [];
          data.map((ele) => {
            ele.label = ele.state_name;
            ele.value = ele.state_id;

            statesKey.push(ele);
          });
          setStates(statesKey);
        } else {
          alert(message);
        }
      })
      .catch((err) => {
        console.log(err);
        setIsLoadinig(false);
      });
  };
  const GetPersonalQues = () => {
    let url = `${endPoints.api.GET_QUESTIONS}`;
    setIsLoadinig(true);
    getAllData(url)
      .then((response) => {
        const { status, data, message } = response;
        setIsLoadinig(false);
        if (status === "success") {
          let statesKey = [];
          data.map((ele) => {
            ele.name = ele.question;
            ele.value = ele.question_id;

            statesKey.push(ele);
          });
          setQuestionArr(statesKey);
        } else {
          alert(message);
        }
      })
      .catch((err) => {
        console.log(err);
        setIsLoadinig(false);
      });
  };
  const GetDocumnets = () => {
    let url = `${endPoints.api.GET_DOCUMENTS}`;
    setIsLoadinig(true);
    getAllData(url)
      .then((response) => {
        const { status, data, message } = response;
        setIsLoadinig(false);
        if (status === "success") {
          let statesKey = [];
          data.map((ele) => {
            ele.name = ele.name;
            ele.value = ele.id;
            statesKey.push(ele);
          });
          setDocumentArr(statesKey);
        } else {
          alert(message);
        }
      })
      .catch((err) => {
        console.log(err);
        setIsLoadinig(false);
      });
  };
  const onChange = (e, fieldName) => {
    if (fieldName == "date") setDate(e.target.value);
    if (fieldName == "name") setName(e.target.value);
    if (fieldName == "surname") setSurname(e.target.value);
    if (fieldName == "nation") setNation(e.target.value);
    if (fieldName == "states") setStates(e.target.value);

    if (fieldName == "town") setTown(e.target.value);
    if (fieldName == "address") setAddress(e.target.value);
    if (fieldName == "docnumber") setDocNum(e.target.value);
    if (fieldName == "secquestion") setsecretq(e.target.value);
    if (fieldName == "gender") setGender(e.target.value);
    if (fieldName == "doctype") setDoctype(e.target.value);
    if (fieldName == "personalres") setPersonalRes(e.target.value);
    if (fieldName == "country") setCountry(e.target.value);
  };

  const handleSubmit = (event) => {
    const form = event.currentTarget;
    event.preventDefault();
    // if (form.checkValidity() === false) {
    //   event.stopPropagation();
    //   setValidated(true);
    //   return;
    // }
     let data1 = {
      type: type,
      idUser:idUser,
      login: userName,
      email: email,
      passwd: password,
      name: name,
      surname: surname,
      activation:activeSuspend,
      documentId: docNum,
      documentTypeId: parseInt(doctype),
      nation: nation,
      country: country,
      town: town,
      address: address,
      personalQuestion: secretq,
      personalResponse: personalres,
      sex: sex,
    };
    if (User?.idUser != undefined) {
      UpdateUser(data1)
   }else{
     CreateUser(data1);
   }
  };

  const CreateUser = (data) => {
    let url = `${endPoints.api.ADD_USER}`;
    setIsLoadinig(true);
    updateUser(url, data)
      .then((response) => {
        setIsLoadinig(false);
     
        if (response.status === "success") {
          setMessage("Succcess");
          SuccesToast(response.message);
          navigate("/UserList");
        } else {
          setMessage(response.message);
          ErrorToast(response.message);
        }
      })
      .catch((error) => {
        setIsLoadinig(false);
        console.error(error);
        ErrorToast(error);
      });
  };

  const UpdateUser = (data) => {
    let url = `${endPoints.api.UPDATE_PERSONAL}`;
    setIsLoadinig(true);
    updateData(url, data)
      .then((response) => {
        setIsLoadinig(false);
        if (response.status === "success") {
          setMessage("Succcess");
          SuccesToast("User Updated Successfully");
        } else {
          setMessage(response.message);
          ErrorToast(response.message);
        }
      })
      .catch((error) => {
        setIsLoadinig(false);
        console.error(error);
        ErrorToast(error);
      });
  };

  return (
    <div>
      <Toaster />
      <div className="container bg-color">
        <div className="inner-divspace">
          <div className="row">
            {isLoading && <Loader spinner={true} visible={isLoading} />}
            <div className="col-md-4">
              <div className="mt-5 form-space-r">
                <Form
                 // noValidate
                  //validated={validated}
                  className="my-form-layout1"
                  onSubmit={handleSubmit}
                >
                   <Form.Group className="mb-3" controlId="Surname">
                    <Form.Label className="my-form-label">Gender</Form.Label>
                    <div className="custom-dropdown">
                    <Form.Select
                      aria-label="Default select example"
                      value={sex}
                      onChange={(e) => onChange(e, "gender")}
                    >
                      <option>Gender</option>
                      <option value="M">Male</option>
                      <option value="F">Female</option>
                    </Form.Select>
                    <span className="custom-dropdown-arrow">
                      <FiChevronDown />
                    </span>
                  </div>
                  </Form.Group>
                  <Form.Group className="mb-3" controlId="Surname">
                    <Form.Label className="my-form-label"> First Name</Form.Label>
                  <Form.Group className="mb-3" controlId="Name">
                    <Form.Control
                      type="text"
                      placeholder="First Name"
                      value={name}
                      onChange={(e) => onChange(e, "name")}
                    />
                  </Form.Group>
                  </Form.Group>
                  <Form.Group className="mb-3" controlId="Surname">
                    <Form.Label className="my-form-label">Last Name</Form.Label>
                  <Form.Group className="mb-3" controlId="Surname">
                    <Form.Control
                      type="text"
                      placeholder="Last NAME"
                      value={surname}
                      onChange={(e) => onChange(e, "surname")}
                    />
                  </Form.Group>
                  </Form.Group>
                  <Form.Group className="mb-3" controlId="Surname">
                    <Form.Label className="my-form-label">UserName</Form.Label>
                  <Form.Group className="mb-3" controlId="Name">
                    <Form.Control
                      required
                      type="text"
                      placeholder="Username"
                      value={userName}
                      onChange={(e) => setUserName(e.target.value)}
                    />
                    </Form.Group>
                  </Form.Group>
                  <Form.Group className="mb-3" controlId="Surname">
                    <Form.Label className="my-form-label">Email </Form.Label>
                  <Form.Group required className="mb-3" controlId="Name">
                    <Form.Control
                      type="text"
                      placeholder="Email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                    />
                  </Form.Group>
                  </Form.Group>
                  <Form.Group className="mb-3" controlId="Surname">
                    <Form.Label className="my-form-label">Password</Form.Label>
                  <Form.Group required className="mb-3" controlId="Name">
                    <Form.Control
                      type="text"
                      placeholder="Password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                    />
                  </Form.Group>
                  </Form.Group>
                  <Button variant="primary" className="save-btn" type="submit">
                    {User?.idUser != undefined ? "Update" : "Create"}
                  </Button>
                </Form>
              </div>
            </div>

            <div className="col-md-4">
              <div className="mt-5 form-space-r">
                <Form className="my-form-layout1">
                <Form.Group className="mb-3" controlId="Surname">
                    <Form.Label className="my-form-label">State</Form.Label>
                  <div className="custom-dropdown">
                    <Form.Select
                      aria-label="Default select example"
                      value={nation}
                      onChange={(e) => onChange(e, "nation")}
                    >
                      <option>State</option>

                      {states.map((item, index) => {
                        return (
                          <option value={item.state_id}>
                            {item.state_name}
                          </option>
                        );
                      })}
                    </Form.Select>
                    <span className="custom-dropdown-arrow">
                      <FiChevronDown />
                    </span>
                  </div>
                  </Form.Group>
                  <Form.Group className="mb-3" controlId="Surname">
                    <Form.Label className="my-form-label">Country</Form.Label>
                  <div className="custom-dropdown">
                    <Form.Select
                      aria-label="Default select example"
                      value={country}
                      onChange={(e) => onChange(e, "country")}
                    >
                      <option>Country</option>
                      <option value="US">US</option>
                    </Form.Select>
                    <span className="custom-dropdown-arrow">
                      <FiChevronDown />
                    </span>
                  </div>
                  </Form.Group>
                  <Form.Group className="mb-3" controlId="Surname">
                    <Form.Label className="my-form-label">Town</Form.Label>
                  <Form.Group className="mb-3" controlId="Town">
                    <Form.Control
                      type="text"
                      placeholder="Town"
                      value={town}
                      onChange={(e) => onChange(e, "town")}
                    />
                    </Form.Group>
                  </Form.Group>
                  <Form.Group className="mb-3" controlId="Surname">
                    <Form.Label className="my-form-label">Address</Form.Label>
                  <Form.Group className="mb-3" controlId="Address">
                    <Form.Control
                      type="text"
                      placeholder="Address"
                      value={address}
                      onChange={(e) => onChange(e, "address")}
                    />
                  </Form.Group>
                  </Form.Group>
                  <Form.Group className="mb-3" controlId="Surname">
                    <Form.Label className="my-form-label">Type of Document</Form.Label>
                  <div className="custom-dropdown">
                    <Form.Select
                      aria-label="Default select example"
                      value={doctype}
                      onChange={(e) => onChange(e, "doctype")}
                    >
                      <option>Type of document</option>
                      {documentArr.map((item) => {
                        return <option value={item.value}>{item.name}</option>;
                      })}
                    </Form.Select>
                    <span className="custom-dropdown-arrow">
                      <FiChevronDown />
                    </span>
                  </div>
                  </Form.Group>
                  <Form.Group className="mb-3" controlId="Surname">
                    <Form.Label className="my-form-label">Document Number</Form.Label>
                  <Form.Group className="mb-3" controlId="Document number">
                    <Form.Control
                      type="text"
                      placeholder="Document number"
                      value={docNum}
                      onChange={(e) => onChange(e, "docnumber")}
                    />
                  </Form.Group>
                  </Form.Group>
                </Form>
              </div>
            </div>

            <div className="col-md-4">
              <div className="mt-5 form-space-r">
                <div className="my-form-layout1">
                  {/* <Form.Group className="mb-3" controlId="Surname">
                                        <Form.Control type="text" placeholder="Surname" />
                                    </Form.Group> */}
                 <Form.Group className="mb-3" controlId="Surname">
                    <Form.Label className="my-form-label">Secret question</Form.Label>
                  <div className="custom-dropdown">
                    <Form.Select
                      aria-label="Default select example"
                      value={secretq}
                      onChange={(e) => onChange(e, "secquestion")}
                    >
                      <option>Secret question</option>
                      {questionArr.map((item) => {
                        return <option value={item.value}>{item.name}</option>;
                      })}
                    </Form.Select>
                    <span className="custom-dropdown-arrow">
                      <FiChevronDown />
                    </span>
                  </div>
                  </Form.Group>
                  <Form.Group className="mb-3" controlId="Surname">
                    <Form.Label className="my-form-label">Personal Response</Form.Label>
                  <Form.Group className="mb-3" controlId="Secret question">
                    <Form.Control
                      type="text"
                      placeholder="Personal response"
                      value={personalres}
                      onChange={(e) => onChange(e, "personalres")}
                    />
                  </Form.Group>
                  </Form.Group>
                  <Form.Group className="mb-3" controlId="Surname">
                    <Form.Label className="my-form-label">Type</Form.Label>
                  <div className="custom-dropdown">
                    <Form.Select
                      aria-label="Default select example"
                      value={type}
                      onChange={(e) => setType(e.target.value)}
                    >
                      <option>Type</option>
                      {typearr.map((item) => {
                        return <option value={item.value}>{item.name}</option>;
                      })}
                    </Form.Select>
                    <span className="custom-dropdown-arrow">
                      <FiChevronDown />
                    </span>
                  </div>
                  </Form.Group>
                  <Form.Group className="mb-3" controlId="Surname">
                    <Form.Label className="my-form-label">Active/Suspend</Form.Label>
                  <div className="custom-dropdown">
                    <Form.Select
                      aria-label="Default select example"
                      value={activeSuspend}
                      onChange={(e) => setActiveSuspend(e.target.value)}
                    >
                      <option>Type</option>
                      {accountType.map((item) => {
                        return <option value={item.value}>{item.name}</option>;
                      })}
                    </Form.Select>
                    <span className="custom-dropdown-arrow">
                      <FiChevronDown />
                    </span>
                  </div>
                  </Form.Group>
                  
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateUser;
